module.exports = __webpack_public_path__ + "img/09.9f3d18e6.png";